import { StudioPermissions } from '@/enums/VersioningStatus';
import { CourseStudioProps } from '../info/CourseStudioInfo.hooks';
import CourseStudioBlocksDetailsStep from './CourseStudioBlocksDetailsStep';
import CourseStudioLessonsDetailsStep from './CourseStudioLessonsDetailsStep';

type Props = CourseStudioProps & {
  studioPermissions: StudioPermissions;
  coursePathId?: number;
};

export default function CourseStudioDetailsStep(props: Props) {
  return (
    <article className="flex flex-col gap-2.5">
      <CourseStudioBlocksDetailsStep {...props} />
      <CourseStudioLessonsDetailsStep {...props} />
    </article>
  );
}
